import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import BackToTopButton from 'components/BackToTopButton/BackToTopButton';
import { mediaQueries } from 'style/config';

/**
 * A specialized BackToTopButton for Creator Storefront that ensures
 * the topPosition prop works on both mobile and desktop screens.
 * We didn't want to change underlying BackToTopButton component, so we created this wrapper.
 */
function CSFBackToTopButton({ analyticsLinkName, topPosition }) {
    // Fixed 80px top spacing for desktop
    const desktopTopPosition = 80;

    return (
        <div css={styles.wrapper(topPosition, desktopTopPosition)}>
            <BackToTopButton
                analyticsLinkName={analyticsLinkName}
                topPosition={topPosition}
            />
        </div>
    );
}

const styles = {
    wrapper: (mobileTopPosition, desktopTopPosition) => ({
        // Target the BackToTopButton's internal container
        '& > div': {
            // Apply desktop position for md and larger screens
            [mediaQueries.md]: {
                top: `${desktopTopPosition}px !important`
            }
        },
        // Additional specificity for the fixed container
        '& > div[style*="position: fixed"]': {
            [mediaQueries.md]: {
                top: `${desktopTopPosition}px !important`
            }
        }
    })
};

export default wrapFunctionalComponent(CSFBackToTopButton, 'CSFBackToTopButton');
